import { useField, useFormikContext } from 'formik';

import { AssignedSupplierSelect, AssignedSupplierSelectProps } from '../CompanySelect/AssignedSupplierSelect';

interface FormikAssignedSupplierSelectProps
    extends Omit<AssignedSupplierSelectProps, 'onChange' | 'value' | 'options'> {
    name: string;
    onChange?: (value: string) => void;
}

export const FormikAssignedSupplierSelect = (props: FormikAssignedSupplierSelectProps) => {
    const { onChange, ...selectProps } = props;
    const [field, meta, helpers] = useField(props.name);
    const { validateOnChange } = useFormikContext();

    return (
        <AssignedSupplierSelect
            {...selectProps}
            value={field.value}
            onChange={(value) => {
                const hasChanged = value !== field.value;
                helpers.setValue(value);
                if (!validateOnChange && meta.error) {
                    helpers.setError(undefined);
                }
                if (hasChanged) {
                    onChange?.(value);
                }
            }}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
};
